import React, { useContext, useState } from "react"
import { AuthContext } from "../context/AuthContext"
import {
    getAuthHeader,
    getAvatarImagePath,
    getImagePath, getLocalStorageItem,
    getPathBack,
    objectLang,
    removeCookieOfFolderId,
    setErrorWindow, setLocalStorageItem,
} from "../functions"
import config from "../config.json"
import { UploadSingleImageClass } from "../components/UploadSingleImageClass"
import {useNavigate} from "react-router-dom"

export const UploadSingleImageFilePage = ({ isAvatar = false }) => {
    setLocalStorageItem("page", "UploadSingleImageFilePage")

    const auth = useContext(AuthContext)
    const documents = getLocalStorageItem("documents")

    const imagePathName = isAvatar ? getAvatarImagePath(auth) : getImagePath(documents, auth)

    const lang = objectLang().language
    const l = lang.lang

    const [disabledButton, setDisabledButton] = useState(true)
    const [progressBarOpacity, setProgressBarOpacity] = useState(0)
    const [nameImageFile, setNameImageFile] = useState("0")
    const navigate = useNavigate()

    const allowedTypes = "image/jpeg, image/png, image/ico, image/gif, image/tiff, image/svg, image/psd"

    const assertFilesValid = (file) => {
        const fileName = file.name
        const fileSize = file.size
        const sizeLimit = 10485760 // 10 MB
        if (!allowedTypes.includes(file.type)) {
            setDisabledButton(true)
            throw new Error(`❌ "${fileName}" - ${lang.body.uploadFilePage.notSupported}`)
        }
        if (fileSize > sizeLimit) {
            setDisabledButton(true)
            throw new Error(`❌ ${lang.body.uploadFilePage.file} "${fileName}" ${lang.body.uploadFilePage.sizeCannot}`)
        }
        document.querySelector("#statusMessage").innerHTML = ` ✅ ${lang.body.uploadFilePage.file} "${fileName}" ${lang.body.uploadFilePage.isReadyToSend}`
        setDisabledButton(false)
    }

    const showPendingState = () => {
        setDisabledButton(true)
        document.querySelector("#statusMessage").innerHTML = ` ⏳ ${lang.body.uploadFilePage.pending}`
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        showPendingState()
        uploadFiles()
    }

    const updateProgressBar = (value) => {
        document.querySelector("progress").value = Math.round(value * 100)
    }

    const changeNameHandler = (e) => setNameImageFile(e.target.value)

    const handleInputChange = (e) => {
        setProgressBarOpacity(100)
        document.querySelector("#statusMessage").innerHTML = ` ${lang.body.uploadFilePage.nothingToUpload}`

        try {
            const file = e.target.files[0]
            assertFilesValid(file)
            const label = document.querySelector(".input__file-button")
            if (file) {
                label.querySelector(".input__file-button-text").innerText = `${lang.body.uploadFilePage.inputTextOne} ${file.name}`
                setNameImageFile(file.name)
                document.querySelector("#file-name").value = file.name
            }
        } catch (err) {
            document.querySelector("#statusMessage").innerHTML = err.message
            return
        }
        setDisabledButton(false)
    }

    const uploadFiles = () => {
        const host = window.location.host === "localhost:3000" ? config.localHost : config.onrender
        const formEl = document.querySelector("#form_file")
        const formData = new FormData(formEl)

        // добавить метаданные в тело, не в заголовки
        formData.append("date-created", Date.now().toString())
        formData.append("name-image-file", encodeURIComponent(nameImageFile))
        formData.append("image-path-name", imagePathName)

        const xhr = new XMLHttpRequest()
        xhr.open("POST", `${host}/api/cloudinary/single-image-upload`)
        xhr.withCredentials = true
        xhr.setRequestHeader("Authorization", getAuthHeader(auth))

        xhr.upload.addEventListener("progress", (event) => {
            document.querySelector("#statusMessage").innerHTML = ` ⏳ ${lang.body.uploadFilePage.uploaded} ${event.loaded} ${lang.body.uploadFilePage.bytesOf} ${event.total}`
            updateProgressBar(event.loaded / event.total)
        })

        xhr.addEventListener("loadend", () => {
            updateProgressBar(1)
            const pathBack = getPathBack()
            if (xhr.status === 200) {
                document.querySelector("#statusMessage").innerHTML = ` ✅ ${lang.body.uploadFilePage.success}`
                const pathBackArr = pathBack.split("/")
                const folderParent = pathBackArr[pathBackArr.length - 1]
                removeCookieOfFolderId(folderParent)
                navigate(getPathBack(), {replace: true})
            } else {
                document.querySelector("#statusMessage").innerHTML = ` ❌ ${lang.body.uploadFilePage.error}`
                setLocalStorageItem("dataModal", setErrorWindow("", "", "", "", `replaceTo ${pathBack}`, "off"))
                navigate(`/${l}/modal`, {replace: true})
            }
        })

        xhr.send(formData)
    }

    return (
        <UploadSingleImageClass
            documents={documents}
            changeNameHandler={changeNameHandler}
            handleInputChange={handleInputChange}
            handleSubmit={handleSubmit}
            disabledButton={disabledButton}
            progressBarOpacity={progressBarOpacity}
            allowedTypes={allowedTypes}
            navigate={navigate}
        />
    )
}
